import { ExternalLink, LegacyDataTableHeaderColumn, LegacyDataTableRow, LegacyDataTableRowColumn, Tooltip } from "@octopusdeploy/design-system-components";
import type { ProjectResource, ProjectChangeFailureRateDeployment } from "@octopusdeploy/octopus-server-client";
import { TenantedDeploymentMode } from "@octopusdeploy/octopus-server-client";
import { links } from "@octopusdeploy/portal-routes";
import { TrendTable } from "~/areas/insights/components/Reports/TrendTables/TrendTable/TrendTable";
import InternalLink from "~/components/Navigation/InternalLink";
import DateFormatter from "~/utils/DateFormatter";
interface Props {
    title: string;
    data: ProjectChangeFailureRateDeployment[];
    project: ProjectResource;
}
export function ProjectFailureRateTrendTable({ title, data, project }: Props) {
    const isTenanted = project.TenantedDeploymentMode != TenantedDeploymentMode.Untenanted;
    return (<TrendTable title={title} isEmpty={data.length === 0} note={<span>
                    The most recent <ExternalLink href="InsightsDeploymentFailureRate">failed deployments</ExternalLink> for the current filter. The first 10 in descending order by completed time are shown.
                </span>} headerContent={<LegacyDataTableRow>
                    {isTenanted && <LegacyDataTableHeaderColumn>Tenant</LegacyDataTableHeaderColumn>}
                    <LegacyDataTableHeaderColumn>Release</LegacyDataTableHeaderColumn>
                    <LegacyDataTableHeaderColumn>Completed</LegacyDataTableHeaderColumn>
                    <LegacyDataTableHeaderColumn>State</LegacyDataTableHeaderColumn>
                    <LegacyDataTableHeaderColumn>Guided failure</LegacyDataTableHeaderColumn>
                </LegacyDataTableRow>} bodyContent={<>
                    {data.map((r) => (<LegacyDataTableRow key={r.Id}>
                            {isTenanted && <LegacyDataTableRowColumn>{r.TenantName}</LegacyDataTableRowColumn>}
                            <LegacyDataTableRowColumn>
                                <InternalLink to={links.releasePage.generateUrl({ spaceId: project.SpaceId, projectSlug: project.Slug, releaseVersion: r.ReleaseVersion })}>{r.ReleaseVersion}</InternalLink>
                            </LegacyDataTableRowColumn>
                            <LegacyDataTableRowColumn>
                                <Tooltip content={DateFormatter.dateToShortFormat(r.CompletedTime) || undefined}>
                                    <InternalLink to={links.deploymentPage.generateUrl({ spaceId: project.SpaceId, projectSlug: project.Slug, releaseVersion: r.ReleaseVersion, deploymentId: r.Id })}>
                                        {DateFormatter.momentAgo(r.CompletedTime)}
                                    </InternalLink>
                                </Tooltip>
                            </LegacyDataTableRowColumn>
                            <LegacyDataTableRowColumn>{r.State}</LegacyDataTableRowColumn>
                            <LegacyDataTableRowColumn>{r.HadGuidedFailure ? "True" : "False"}</LegacyDataTableRowColumn>
                        </LegacyDataTableRow>))}
                </>}/>);
}
